















































import { Component, Vue } from "vue-property-decorator";
import {
 getZipFileList
} from "@/serve/xiaohaAssistant/physicalZip";
import { Calendar } from "element-ui";
import { Card, Switch, TimePicker, TimeSelect } from "element-ui";
// 定义表单类型接口
interface FormType {
  title: string;
  startTime: any;
  endTime: any;
  status: boolean;
  sort: string | number;
  description: string;
  type: string | number;// 1:上午 2:下午 3:晚上;
}
@Component({
  name: "companyManage",
  components: { Calendar, Card, Switch, TimePicker, TimeSelect },
})
export default class MedicalReport extends Vue {
  private rules = {
    title: [
      { required: true, message: "请输入标题", trigger: "blur" },
      { min: 1, max: 16, message: "长度在 1 到 16 个字符", trigger: "blur" },
    ],
  };
  public itemDialog = false;
  public form: FormType = {
    //标题
    title: "",
    // 开始时间
    startTime: null,
    // 结束时间
    endTime: "",
    // 状态
    status: true,
    // 排序
    sort: "",
    // 说明
    description: "",
    // 时间段类型
    type: "2",
  };

  public formData = {
    title: "",
    status: "",
    type:"2"
  };
  // 新增时间段addNew
  public addNew() {
    this.form = {
      //标题
      title: "",
      // 开始时间
      startTime: new Date(2023, 0, 1, 7, 0),
      // 结束时间
      endTime: new Date(2023, 0, 1, 7, 0),
      // 状态
      status: true,
      // 排序
      sort: "",
      // 说明
      description: "",
      // 时间段类型
      type: "1",
    };
    this.itemDialog = true;
  }
  public handleStartTimeChange(val: any) {
    this.form.endTime = val;
  }

  //日期选择器
  public value = new Date();
  //是否展示号源编辑框
  public dialogTime = false;
  public tableData = [];
  public created() {
    //获取列表
    this.getReportList();
  }
  // 获取数据接口
  public async getReportList() {
    getZipFileList().then((res: any) => {
      this.tableData = res.data;
    });
  }

  public changeSoure(data: any) {
    console.log("data",data);
    const a = document.createElement('a');
      // 关键1：使用 encodeURIComponent 编码原始文件名（GBK），避免 Nginx 404
      a.href = data.url;
      // 关键2：设置 download 属性为 UTF-8 中文文件名，解决下载后乱码
      a.download = data.fileName;
      a.click();
      document.body.removeChild(a);

  }
}
